module.exports = __webpack_public_path__ + "img/pepe-rainbow.f255990d.gif";